export default __webpack_public_path__ + "static/media/CRM.8d071716.gif";